import * as yup from 'yup'

export const ModalSolutionOutPositionSchema = yup.object().shape({
	cause: yup.string().required('required').nullable(),
})
